import axios from "axios";
import { Link } from "react-router-dom";
import React, { useState, useEffect, useMemo, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate, useLocation } from "react-router-dom";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import {
  faArrowLeft,
  faEye,
  faImage,
} from "@fortawesome/free-solid-svg-icons";

const containerStyle = {
  width: "100%",
  height: "50vh",
};
const center = {
  lat: 28.641832439372656,
  lng: 77.22480777651072,
};

const PKVYFarmerList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const initialState = location.state; // initial data passed via router
  const [farmerDetails, setFarmerDetails] = useState(initialState || null);
  const [cropSurveyData, setCropSurveyData] = useState(null);
  const [componentName, setComponentName] = useState("");
  const [activeImage, setActiveImage] = useState(null);
  const [coconutName, setCoconutName] = useState("");
  const [seasons, setSeasons] = useState([]);
 
  const [map, setMap] = useState(null);

  // Determine schemeCodeModel from sessionStorage
  const schemeCodeModel = sessionStorage.getItem("schemeCodeModel");

  // Flag to ensure fetch is only done once.
  const [fetched, setFetched] = useState(false);

  // When the component mounts (or farmerDetails changes), fetch detailed data if needed
  useEffect(() => {
  	
    if (farmerDetails && !fetched) {

      console.log("Initial farmer details:::::", farmerDetails.farmerCode);
      setCropSurveyData(farmerDetails.farmerCode)
      console.log("Initial farmer details:11111111111111111", farmerDetails.farmerCode.farmerCode);
      // For schemeCodeModel "14" or if it's not set, fetch NMEOOP details only once
      if (schemeCodeModel === "" || !schemeCodeModel) {
        fetchDetailedDataPKVY(farmerDetails.farmerCode.farmerCode);
        setFetched(true);
      }
    }
  }, [farmerDetails, schemeCodeModel, fetched]);

  async function fetchDetailedDataPKVY(value) {
  	
    try {
      const result = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/PKVY/getFarmerDetailsByFilter`,
        {
          surveyUserCode: "0",
          mobileNo: "",
          schemeCode: "0",
          orgTypeCode: "0",
          farmerCode: "0",
          stateCode: "0",
          districtCode: "0",
          subDistrictCode: "0",
          blockCode: "0",
          villageCode: "0",
          surveyNo: "",
          farmerCode:value
          
        }
      );
      const data = result.data.dataContent[0];
      console.log("datadatadatadata",data);
      // Update our local state with the fetched details
      setFarmerDetails(data);
      //setCropSurveyData(data);
    } catch (error) {
      console.error("Error fetching NMEOOP details:", error);
    }
  }

  useEffect(() => {
    const fetchSeasons = async () => {
      try {
        const baseUrl =
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE;
        const res = await axios.get(`${baseUrl}/api/seasons`);
        setSeasons(res?.data?.dataContent || []);
      } catch (err) {
        console.error("Error fetching seasons:", err);
      }
    };
    fetchSeasons();
  }, []);

  

  const onLoad = useCallback(
    (mapInstance) => {
      setMap(mapInstance);

      if (
        !cropSurveyData ||
        !Array.isArray(cropSurveyData.polygons) ||
        cropSurveyData.polygons.length === 0
      ) {
        console.log(
          "No polygon data available---------",
          cropSurveyData && cropSurveyData.polygons
        );
        return;
      }

      const polygons = [];
      const markers = [];
      const infoWindows = [];

      cropSurveyData.polygons.forEach((polyItem) => {
        let parsedPolygon;
        try {
          parsedPolygon =
            typeof polyItem.polygonShape === "string"
              ? JSON.parse(polyItem.polygonShape)
              : polyItem.polygonShape;
        } catch (error) {
          console.error("Error parsing polygon shape:", error);
          return;
        }

        if (!Array.isArray(parsedPolygon) || parsedPolygon.length === 0) {
          return;
        }

        const polygon = new window.google.maps.Polygon({
          paths: parsedPolygon,
          strokeColor: "#FF0000",
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: "#FF0000",
          fillOpacity: 0.1,
          content: `Crop Land Area: ${polyItem.cropLandArea || ""}`,
        });

        const infoWindow = new window.google.maps.InfoWindow({
          content: `<div id="infoContent"><strong>Crop Land Area:</strong> ${
            polyItem.cropLandArea || ""
          }</div>`,
        });

        polygon.addListener("mouseover", function () {
          infoWindow.setContent(this.content);
          infoWindow.open(mapInstance);
        });
        polygon.addListener("mouseout", function () {
          infoWindow.close();
        });

        polygon.setMap(mapInstance);

        const bounds = new window.google.maps.LatLngBounds();
        parsedPolygon.forEach((point) => {
          bounds.extend(point);
        });
        const newCenter = bounds.getCenter();
        mapInstance.setCenter(newCenter);

        const marker = new window.google.maps.Marker({
          position: newCenter,
          map: mapInstance,
          title: "Click to zoom",
        });
        marker.addListener("click", () => {
          mapInstance.panTo(marker.getPosition());
          mapInstance.setZoom(18);
        });

        polygons.push(polygon);
        markers.push(marker);
        infoWindows.push(infoWindow);
      });
    },
    [cropSurveyData]
  );

  const onUnmount = useCallback((mapInstance) => {
    setMap(null);
  }, []);

  // Example columns for a table if needed
  const columns = useMemo(
    () => [
      {
        header: "S.No",
        Cell: (cell) => Number(cell.row.id) + 1,
      },
      {
        accessorKey: "farmerName",
        header: "Farmer Name",
      },
      {
        accessorKey: "cropStageName",
        header: "Crop Stage",
      },
      {
        accessorKey: "cropRatio",
        header: "Ratio(%)",
      },
      {
        accessorKey: "dateofSowing",
        header: "Date of Sowing",
      },
      {
        accessorKey: "croppingPattern",
        header: "Cropping Pattern",
      },
    ],
    []
  );

  const getSeasonName = (code) => {
    if (!code || !Array.isArray(seasons)) return "";
    const numeric = Number(code);
    const match = seasons.find(
      (s) => Number(s.seasonCode) === numeric
    );
    return match ? match.seasonName : code;
  };

  function maskAadhaar(value) {
    if (!value) return "";
    const str = String(value);
    if (str.length <= 4) return str;
    const last4 = str.slice(-4);
    const maskedCount = str.length - 4;
    return "x".repeat(maskedCount) + last4;
  }

  // Handle active image click for a modal (reuse FarmerDetailView modal)
  function handleActiveClick(index) {
    setActiveImage(index);
    if (
      cropSurveyData &&
      cropSurveyData.images.length > 0 &&
      cropSurveyData.images[index]
    ) {
      const imagePath = cropSurveyData.images[index].imagepath;
      const innerHTML = `<img src="${imagePath}" alt="Farmer Image" class="img-fluid w-100 h-50" />`;
      const modalBody = document.getElementById("modalBody");
      if (modalBody) {
        modalBody.innerHTML = innerHTML;
      }
    }
  }

 return (
  <main id="main" className="main">
    <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
      <nav>
        <h1>Project Details View</h1>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">Project</li>
          <li className="breadcrumb-item active">Project Details View</li>
        </ol>
      </nav>
      <button
        type="button"
        className="btn btn-success"
        onClick={() => navigate("/newadminpanel/farmer")}
      >
        <i>
          <FontAwesomeIcon icon={faArrowLeft} />
        </i>{" "}
        Back
      </button>
    </div>
    <section className="section">
      <div className="row">
        <div className="col-lg-12 dashboard">
          <div className="card">
            {/* Render data only if cropSurveyData exists and schemeCodeModel is "14" or not set */}
            {cropSurveyData && (schemeCodeModel === "22" || !schemeCodeModel) && (
              <div className="card-body p-5 pt-2">
                {/* Polygon Details */}
                <div className="row cropview">
                  <h5 className="formgrouping">Polygon Details</h5>
              
                    <GoogleMap
                      mapContainerStyle={containerStyle}
                      center={center}
                      zoom={18}
                      onLoad={onLoad}
                      onUnmount={onUnmount}
                      mapTypeId="satellite"
                    />
                
                </div>
                {/* Survey Details */}
                <div className="row cropview">
                  <h5 className="formgrouping ">Survey Details</h5>
                  <div className="row surveydetailsbg">
                    {(cropSurveyData.landSurveyNumber ) && (
                      <div className="col-md-3">
                        <h6>Survey No.</h6>
                        <p>{cropSurveyData.landSurveyNumber }</p>
                      </div>
                    )}
                    {cropSurveyData.farmerID && (
                      <div className="col-md-3">
                        <h6>Farmer Id</h6>
                        <p>{cropSurveyData.farmerID}</p>
                      </div>
                    )}
                    {cropSurveyData.farmID && (
                      <div className="col-md-3">
                        <h6>Farm Id</h6>
                        <p>{cropSurveyData.farmID}</p>
                      </div>
                    )}
                    {cropSurveyData.finYear && (
                      <div className="col-md-3">
                        <h6>Financial Year</h6>
                        <p>{cropSurveyData.finYear}</p>
                      </div>
                    )}
                    {cropSurveyData.categoryName && (
                      <div className="col-md-3">
                        <h6>Category</h6>
                        <p>{cropSurveyData.categoryName}</p>
                      </div>
                    )}
                    {cropSurveyData.typeName && (
                      <div className="col-md-3">
                        <h6>Type</h6>
                        <p>{cropSurveyData.typeName}</p>
                      </div>
                    )}
                    {cropSurveyData.cropLifeCycleName && (
                      <div className="col-md-3">
                        <h6>Crop Life Cycle</h6>
                        <p>{cropSurveyData.cropLifeCycleName}</p>
                      </div>
                    )}
                    {cropSurveyData.gardenAgeName && (
                      <div className="col-md-3">
                        <h6>Garden Age</h6>
                        <p>{cropSurveyData.gardenAgeName}</p>
                      </div>
                    )}
                    {cropSurveyData.schemeName && (
                      <div className="col-md-3">
                        <h6>Scheme Name</h6>
                        <p>{cropSurveyData.schemeName}</p>
                      </div>
                    )}
                    {(cropSurveyData.CropCategoryName ||
                      cropSurveyData.cropCategoryName) && (
                      <div className="col-md-3">
                        <h6>Crop Category Name</h6>
                        <p>{cropSurveyData.CropCategoryName || cropSurveyData.cropCategoryName}</p>
                      </div>
                    )}
                    {cropSurveyData.CropName || cropSurveyData.cropName ? (
                      <div className="col-md-3">
                        <h6>Crop Name</h6>
                        <p>{cropSurveyData.CropName || cropSurveyData.cropName}</p>
                      </div>
                    ) : null}
                    {cropSurveyData.SeasonName || cropSurveyData.seasonName ? (
                      <div className="col-md-3">
                        <h6>Season Name</h6>
                        <p>{cropSurveyData.SeasonName || cropSurveyData.seasonName}</p>
                      </div>
                    ) : null}
                    {cropSurveyData.areaCovered_Ha && (
                      <div className="col-md-3">
                        <h6>Area Covered (Ha)</h6>
                        <p>{cropSurveyData.areaCovered_Ha}</p>
                      </div>
                    )}
                    {cropSurveyData.totalAreaInHA && (
                      <div className="col-md-3">
                        <h6>Total Area (Ha)</h6>
                        <p>{cropSurveyData.totalAreaInHA}</p>
                      </div>
                    )}
                    {Array.isArray(cropSurveyData.crops) &&
                      cropSurveyData.crops.length > 0 &&
                      cropSurveyData.crops[0].seasonCode && (
                        <div className="col-md-3">
                          <h6>Season</h6>
                          <p>{getSeasonName(cropSurveyData.crops[0].seasonCode)}</p>
                        </div>
                      )}
                  </div>

                  {Array.isArray(cropSurveyData.crops) &&
                    cropSurveyData.crops.length > 0 && (
                      <div className="col-md-12 mt-3">
                        <h6>Crop Details</h6>
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th scope="col">S.No</th>
                              <th scope="col">Crop Name</th>
                              <th scope="col">Yield</th>
                            </tr>
                          </thead>
                          <tbody>
                            {cropSurveyData.crops.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.cropName}</td>
                                <td>{item.yield}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                </div>

                {/* Personal Details */}
                <div className="row cropview">
                  <h5 className="formgrouping">Personal Details</h5>
                  <div className="row surveydetailsbg">
                    {cropSurveyData.farmerName && (
                      <div className="col-md-3">
                        <h6>Farmer Name</h6>
                        <p>{cropSurveyData.farmerName}</p>
                      </div>
                    )}
                    {cropSurveyData.fatherName && (
                      <div className="col-md-3">
                        <h6>Father / Husband Name</h6>
                        <p>{cropSurveyData.fatherName}</p>
                      </div>
                    )}
                    {cropSurveyData.aadharNo ? (
                      <div className="col-md-3">
                        <h6>Aadhaar No.</h6>
                        <p>{maskAadhaar(cropSurveyData.aadharNo)}</p>
                      </div>
                    ) : null}
                    {cropSurveyData.mobile_No || cropSurveyData.mobileNo ? (
                      <div className="col-md-3">
                        <h6>Mobile No.</h6>
                        <p>{cropSurveyData.mobile_No || cropSurveyData.mobileNo}</p>
                      </div>
                    ) : null}
                    {cropSurveyData.address && (
                      <div className="col-md-3">
                        <h6>Address</h6>
                        <p>{cropSurveyData.address}</p>
                      </div>
                    )}
                    {cropSurveyData.gender && (
                      <div className="col-md-3">
                        <h6>Gender</h6>
                        <p>
                          {/* {cropSurveyData.gender === "M"
                            ? "Male"
                            : cropSurveyData.gender === "F"
                            ? "Female"
                            : cropSurveyData.gender === "T"
                            ? "Transgender"
                            : "NA"} */}
                            {cropSurveyData.gender}
                        </p>
                      </div>
                    )}
                    {cropSurveyData.casteCatName && (
                      <div className="col-md-3">
                        <h6>Caste Category</h6>
                        <p>{cropSurveyData.casteCatName}</p>
                      </div>
                    )}
                    {cropSurveyData.farmerType && (
                      <div className="col-md-3">
                        <h6>Farmer Type</h6>
                        <p>
                          {cropSurveyData.farmerType === 1
                            ? "Small and Marginal"
                            : "Other"}
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Place Details */}
                <div className="row cropview">
                  <h5 className="formgrouping">Place Details</h5>
                  <div className="row surveydetailsbg">
                    {cropSurveyData.stateName && (
                      <div className="col-md-3">
                        <h6>State</h6>
                        <p>{cropSurveyData.stateName}</p>
                      </div>
                    )}
                    {cropSurveyData.districtName && (
                      <div className="col-md-3">
                        <h6>District</h6>
                        <p>{cropSurveyData.districtName}</p>
                      </div>
                    )}
                    {cropSurveyData.subDistrictName && (
                      <div className="col-md-3">
                        <h6>Sub District</h6>
                        <p>{cropSurveyData.subDistrictName}</p>
                      </div>
                    )}
                    {cropSurveyData.villageName && (
                      <div className="col-md-3">
                        <h6>Village</h6>
                        <p>{cropSurveyData.villageName}</p>
                      </div>
                    )}
                  </div>
                </div>


                {/* Farmer Plot Registration List */}
                {cropSurveyData.farmerPlotRegistrationList &&
                  cropSurveyData.farmerPlotRegistrationList.length !== 0 && (
                    <>
                      <h5 className="formgrouping">Farmer Plot Registration List</h5>
                      <div className="row">
                        {cropSurveyData.farmerPlotRegistrationList.map(
                          (item, index) => (
                            <React.Fragment key={index}>
                              {item.farmerId && (
                                <div className="col-md-3">
                                  <h6>Farmer Id</h6>
                                  <p>{item.farmerId}</p>
                                </div>
                              )}
                              {item.plotId && (
                                <div className="col-md-3">
                                  <h6>Plot Id</h6>
                                  <p>{item.plotId}</p>
                                </div>
                              )}
                              {item.plotTotalArea && (
                                <div className="col-md-3">
                                  <h6>Plot Total Area</h6>
                                  <p>{item.plotTotalArea}</p>
                                </div>
                              )}
                              {item.plotatAreaCultivation && (
                                <div className="col-md-3">
                                  <h6>Area Under Cultivation</h6>
                                  <p>{item.plotatAreaCultivation}</p>
                                </div>
                              )}
                              {item.numofoilpalmtrees && (
                                <div className="col-md-3">
                                  <h6>Number of Oil Palm Trees</h6>
                                  <p>{item.numofoilpalmtrees}</p>
                                </div>
                              )}
                              {item.surveyNo && (
                                <div className="col-md-3">
                                  <h6>Survey No.</h6>
                                  <p>{item.surveyNo}</p>
                                </div>
                              )}
                              {item.plotCode && (
                                <div className="col-md-3">
                                  <h6>Plot Code</h6>
                                  <p>{item.plotCode}</p>
                                </div>
                              )}
                              {item.plantMonthYear && (
                                <div className="col-md-3">
                                  <h6>Plant Month/Year</h6>
                                  <p>{item.plantMonthYear}</p>
                                </div>
                              )}
                              {item.fbbProduction && (
                                <div className="col-md-3">
                                  <h6>FBB Production</h6>
                                  <p>{item.fbbProduction}</p>
                                </div>
                              )}
                              {item.agencyName && (
                                <div className="col-md-3">
                                  <h6>Agency Name</h6>
                                  <p>{item.agencyName}</p>
                                </div>
                              )}
                              {item.createdOn && (
                                <div className="col-md-3">
                                  <h6>Created On</h6>
                                  <p>{item.createdOn.split("T")[0]}</p>
                                </div>
                              )}
                            </React.Fragment>
                          )
                        )}
                      </div>
                    </>
                  )}
                {/* Image Details */}
                {cropSurveyData.images &&
                  cropSurveyData.images.length > 0 && (
                    <div className="row cropview">
                      <h5 className="formgrouping">Image Details</h5>
                      {cropSurveyData.images.map((item, index) => (
                        <React.Fragment key={index}>
                          <div className="col-md-2">
                            <img
                               src={
                                          process.env.NODE_ENV === "development"
                                            ? process.env.REACT_APP_DEV_MODE +
                                            "/api/common/GetAttachbyURL?imageURL=" +
                                            item.imagepath
                                            : process.env.REACT_APP_PRO_MODE +
                                            "/api/common/GetAttachbyURL?imageURL=" +
                                            item.imagepath
                                        }
                              alt="Farmer Image"
                              data-bs-toggle="modal"
                              data-bs-target="#staticBackdrop"
                              className="img-fluid imgdetials"
                              onClick={() => handleActiveClick(index)}
                            />
                          </div>
                          <div className="col-md-4">
                            <div className="row imgdetialsbg">
                              <div className="col-md-6">
                                <h6>Latitude</h6>
                                <p>{item.imageLat}</p>
                              </div>
                              <div className="col-md-6">
                                <h6>Longitude</h6>
                                <p>{item.imageLong}</p>
                              </div>
                            </div>
                          </div>
                        </React.Fragment>
                      ))}
                    </div>
                  )}


              </div>
            )}
          </div>
        </div>
      </div>
      </section>
    </main>
  );
};

export default PKVYFarmerList;
